import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.DokumentUploadDaten
 * Modell für ein einzelnes auf Konvertierbarkeit zu prüfendes Dokument, z. Zt. nur FileId
 * Endpoints: /api/documents/checkconvertible
 */
export class DokumentUploadDatenApi extends BaseApiModel {
	constructor(initialProperties?: Partial<DokumentUploadDatenApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected fileId: string;
	/**
	 * Description: Id unter der die Datei im Uploadstore zu finden ist
	 * APIL Type: uuid
	 */
	get FileId(): string {
		return this.fileId;
	}

	/**
	 * Description: Id unter der die Datei im Uploadstore zu finden ist
	 * APIL Type: uuid
	 */
	set FileId(value: string) {
		this.fileId = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): DokumentUploadDatenApi {
		return AppUtils.Helper.createFromMap(dataObject, DokumentUploadDatenApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.FileId = this.fileId;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}